import React, { useState } from 'react';
// import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import Link from 'next/link';
import { Slider } from 'antd';
import CheckMark from '../../layout/checkmark/Dark';

function AvailableFeature(props) {
  return (
    <li className="flex space-x-2 items-center">
      <div>
        <CheckMark />
      </div>
      <span>{props.feature}</span>
    </li>
  );
}

function UnAvailableFeature(props) {
  return (
    <li className="flex space-x-2 items-center opacity-25">
      <div className="w-6 h-6">&nbsp;</div>
      <span>{props.feature}</span>
    </li>
  );
}
export function Pricing(props) {
  const [sliderValue, setSliderValue] = useState(1500);
  return (
    <div className="bg-gradient-to-b from-black to-gray-900 mt-14 md:mt-20">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8 xl:px-4 pb-12 lg:pb-16 xl:pb-24">
        <div className="text-center mb-4 md:mb-6">
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-4">
            For Modern Schools
          </h2>
          {/* <p className="text-lg xl:text-xl text-gray-200">
                            We offer 100% money back guarantee.
                        </p> */}
        </div>

        <div className="mb-8 md:mb-20 lg:mb-24 py-2 mx-1 lg:mx-36">
          <p className="text-gray-200 text-center mb-1 mt-3">
            Students in your school: up to {sliderValue}
          </p>
          <Slider
            value={sliderValue}
            onChange={setSliderValue}
            min={200}
            max={3000}
            step={200}
            marks={{
              200: {
                label: <span className="text-white">200</span>,
              },
              2800: {
                label: <span className="text-white">Contact us</span>,
              },
              3000: {
                label: <span className="text-white">+</span>,
              },
            }}
            tipFormatter={(value) => {
              if (value >= 2800) {
                return 'Contact us';
              }
              return `${value} students`;
            }}
          />
        </div>

        {/* <div className="flex justify-center mb-8 md:mb-20 lg:mb-24">
                        <nav className="inline-flex bg-indigo-100  overflow-hidden text-sm">
                            <button className="font-bold focus:outline-none py-3 px-6 bg-gradient-to-br from-indigo-600 to-indigo-700 hover:from-indigo-500 hover:to-indigo-700 text-white">
                                Pay Yearly
                            </button>
                            <button className="font-bold focus:outline-none py-3 px-6 text-indigo-500 hover:bg-indigo-50">
                                Pay per Term
                            </button>
                        </nav>
                    </div> */}

        <div className="grid md:grid-cols-3 gap-x-8 gap-y-8 items-start">
          <div className="p-4 md:p-8 bg-gray-900">
            <div className="flex justify-between items-baseline mb-4">
              <h4 className="text-white text-xl lg:text-2xl font-bold">Basic</h4>
              <span className="lg:text-xl font-bold">KSh 60 per student</span>
            </div>
            {/* <p className="text-gray-200 mb-6 text-lg">
                                Wisdom is easily acquired when hiding under the
                                bed with.
                            </p> */}
            <Link href="/get-started">
              <a className="analytics-plans-get-started-submit border border-gray-700 block text-center py-3 px-5 lg:px-8 font-bold mb-8 bg-gradient-to-br hover:from-indigo-500 hover:to-indigo-700 hover:text-white">
                Get started
              </a>
            </Link>
            <ul className="text-gray-200 space-y-4 text-lg">
              <AvailableFeature
                feature={`${(sliderValue * 9).toLocaleString(
                  'en-US',
                )}+ SMS messages per year to staff, students & parents`}
              />
              <AvailableFeature
                feature={`${(sliderValue * 1 * 60).toLocaleString(
                  'en-US',
                )}+ Emails per year to staff, students & parents`}
              />
              <AvailableFeature feature="Staff web portal" />
              <AvailableFeature feature="Staff information record" />
              <AvailableFeature feature="Students & parents web portal" />
              <AvailableFeature feature="Exam results analysis" />
              <AvailableFeature feature="Students & parents receive exam results by SMS & Email" />
              <AvailableFeature feature="Library management system" />
              <AvailableFeature feature="Online assignments & holiday homework management system" />
              <UnAvailableFeature feature="Student app" />
              <UnAvailableFeature feature="Mobile support" />
            </ul>
          </div>
          <div className="p-4 md:p-8 lg:py-12 md:transform md:-translate-y-10 md:-mb-10 bg-gray-900 md:shadow-md md:hover:shadow-xl md:transition-all md:duration-500 border-2 md:border border-black">
            <div className="flex justify-between items-baseline mb-4">
              <h4 className="text-white text-xl lg:text-2xl font-bold">Standard</h4>
              <span className="text-l lg:text-xl font-bold">KSh 100 per student</span>
            </div>
            {/* <p className="text-gray-200 mb-6 text-lg">
                                Wisdom is easily acquired when hiding under the
                                bed with.
                            </p> */}
            <Link href="/get-started">
              <a className="analytics-plans-get-started-submit border border-gray-700 block text-center py-3 px-5 lg:px-8 font-bold bg-gradient-to-br from-indigo-600 to-indigo-700 hover:from-indigo-500 hover:to-indigo-700  text-white mb-8">
                Get started
              </a>
            </Link>
            <ul className="text-gray-200 space-y-4 text-lg">
              <AvailableFeature
                feature={`${(sliderValue * 21).toLocaleString(
                  'en-US',
                )}+ SMS messages per year to staff, students & parents`}
              />
              <AvailableFeature
                feature={`${(sliderValue * 1.5 * 100).toLocaleString(
                  'en-US',
                )}+ Emails per year to staff, students & parents`}
              />
              <AvailableFeature feature="Staff web portal" />
              <AvailableFeature feature="Staff information record" />
              <AvailableFeature feature="Students & parents web portal" />
              <AvailableFeature feature="Exam results analysis" />
              <AvailableFeature feature="Students & parents receive exam results by SMS & Email" />
              <AvailableFeature feature="Library management system" />
              <AvailableFeature feature="Online assignments & holiday homework management system" />
              <AvailableFeature feature="Student app" />
              <UnAvailableFeature feature="Mobile support" />
            </ul>
          </div>
          <div className="p-4 md:p-8   bg-gray-900">
            <div className="flex justify-between items-baseline mb-4">
              <h4 className="text-white text-xl lg:text-2xl font-bold">Premium</h4>
              <span className="text-l lg:text-xl font-bold">KSh 200 per student</span>
            </div>
            {/* <p className="text-gray-200 mb-6 text-lg">
                                Wisdom is easily acquired when hiding under the
                                bed with.
                            </p> */}
            <Link href="/get-started">
              <a className="analytics-plans-get-started-submit border border-gray-700  block text-center py-3 px-5 lg:px-8 font-bold mb-8 bg-gradient-to-br hover:from-indigo-500 hover:to-indigo-700 hover:text-white">
                Get started
              </a>
            </Link>
            <ul className="text-gray-200 space-y-4 text-lg">
              <AvailableFeature
                feature={`${(sliderValue * 50).toLocaleString(
                  'en-US',
                )}+ SMS messages per year to staff, students & parents`}
              />
              <AvailableFeature
                feature={`${(sliderValue * 2 * 200).toLocaleString(
                  'en-US',
                )}+ Emails per year to staff, students & parents`}
              />
              <AvailableFeature feature="Staff web portal" />
              <AvailableFeature feature="Staff information record" />
              <AvailableFeature feature="Students & parents web portal" />
              <AvailableFeature feature="Exam results analysis" />
              <AvailableFeature feature="Students & parents receive exam results by SMS & Email" />
              <AvailableFeature feature="Library management system" />
              <AvailableFeature feature="Online assignments & holiday homework management system" />
              <AvailableFeature feature="Student app" />
              <AvailableFeature feature="Mobile support" />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

Pricing.propTypes = {
  // props: PropTypes
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Pricing);
